import React from "react";
import { Gem } from "lucide-react";
import { formatDate } from "@/lib/format";

export function ReviewReply({ reply }) {
  if (!reply) return null;
  return (
    <div className="mt-5 border-l-2 border-gold bg-gold-light/70 px-4 py-3.5" data-testid="review-reply">
      <div className="flex flex-wrap items-center justify-between gap-2">
        <span className="inline-flex items-center gap-1.5 text-[10px] uppercase tracking-widest text-gold" data-testid="review-reply-author">
          <Gem size={12} /> Response from {reply.author}
        </span>
        <time className="text-[11px] text-muted-foreground" dateTime={reply.created_at}>{formatDate(reply.created_at)}</time>
      </div>
      <p className="mt-2 text-sm leading-relaxed text-ink/90" data-testid="review-reply-body">{reply.body}</p>
    </div>
  );
}
